import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const BusinessCostResultsRoot = superstyled({
  name: 'BusinessResults',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.border.main}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius
  })
});

export const ReportHeader = superstyled({
  name: 'BusinessCostResults',
  slot: 'ReportHeader',
  tag: Box,
  styles: () => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  })
});

export const ReportContent = superstyled({
  name: 'BusinessCostResults',
  slot: 'ReportContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  })
});
